import { render, staticRenderFns } from "./GroupParle.vue?vue&type=template&id=e717fad8&"
import script from "./GroupParle.vue?vue&type=script&lang=js&"
export * from "./GroupParle.vue?vue&type=script&lang=js&"
import style0 from "./GroupParle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports